module.exports = __webpack_public_path__ + "img/e_2_16_g.3fd9ad8e.png";